import { useRef, useEffect, useCallback } from 'react';
import { useLocation, useNavigationType } from 'react-router';

var ROUTING_INSTRUMENTATION = 'react-router-v6-instrumentation';

var TAGS = {
    'routing.instrumentation': ROUTING_INSTRUMENTATION,
};

function useRoutingInstrumentation() {
    var pathname = useLocation().pathname;
    var navigationType = useNavigationType();
    var activeTransaction = useRef();
    var pathnameRef = useRef(pathname);
    var customStartTransaction = useRef();
    var startTransactionOnLocationChange = useRef(true);
    var isIgnoredNavigationType = navigationType !== 'POP' && navigationType !== 'PUSH';
    useEffect(function () {
        if (typeof customStartTransaction.current !== 'function' ||
            !startTransactionOnLocationChange.current ||
            isIgnoredNavigationType) {
            return;
        }
        if (activeTransaction.current) {
            activeTransaction.current.finish();
        }
        activeTransaction.current = customStartTransaction.current({
            name: pathname,
            op: 'navigation',
            tags: TAGS,
        });
    }, [isIgnoredNavigationType, pathname]);
    useEffect(function () {
        return function () {
            if (typeof activeTransaction.current === 'undefined') {
                return;
            }
            activeTransaction.current.finish();
        };
    }, []);
    pathnameRef.current = pathname;
    return useCallback(function (newCustomStartTransaction, startTransactionOnPageLoad, newStartTransactionOnLocationChange) {
        if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
        if (newStartTransactionOnLocationChange === void 0) { newStartTransactionOnLocationChange = true; }
        customStartTransaction.current = newCustomStartTransaction;
        startTransactionOnLocationChange.current =
            newStartTransactionOnLocationChange;
        if (!startTransactionOnPageLoad) {
            return;
        }
        activeTransaction.current = newCustomStartTransaction({
            name: pathnameRef.current,
            op: 'pageload',
            tags: TAGS,
        });
    }, []);
}

export { useRoutingInstrumentation as default };
